<div class="collection-controller">
  <app-layer-manager-widget
    [collectionLayer]="viewerService.collectionLayers$ | async"
    [overlayLayers]="viewerService.overlayLayers$ | async"
    [dualViewEnabled]="false"
    [aois]="(viewerService.projectStatus$ | async)?.enabledAOIs"
    [isActivatedAutoContrast]="viewerService.enableContrast$ | async"
    [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"></app-layer-manager-widget>
  <app-infrared-selector
    *ngIf="(flagService.getFlags$() | async)?.[FeatureFlags.INFRARED] && !viewerService.is3DMode()"
    [active]="viewerService.infraredStatus$ | async"
    [activeTrigger]="viewerService.infraredTrigger$ | async"
    [enabled]="enableInfraredButton"
    matTooltip="{{ enableInfraredButton ? 'View color Infrared imagery at this location' : 'CIR imagery not available' }}"></app-infrared-selector>
    <div *ngIf="(flagService.getFlags$() | async)?.[FeatureFlags.INFRARED] && showInfraredButton3D"
         matTooltip="{{ enableInfraredButton ? 'Vertical CIR imagery' : 'Vertical CIR imagery not available' }}">
        <button
                matMiniFab
                [disabled]="!enableInfraredButton"
                type="button"
                class="infrared-button"
                [class.selected]="orientation === 'I'"
                (click)="loadInfraredImage()">
            CIR
        </button>
    </div>

  <button
    matMiniFab
    *ngIf="is3D && enableNadirButton()"
    matTooltip="View vertical images"
    type="button"
    [class.selected]="orientation === 'N*'"
    (click)="loadNadirImage()">
    V
  </button>
  <!-- AI Chat Button -->
  <button
    matMiniFab
    matTooltip="AI Assistant"
    matTooltipPosition="left"
    [hidden]="!agents.length"
    (click)="toggleChatPanel()"
    [class.selected]="chatPanelOpen"
    cdkOverlayOrigin
    #chatTrigger="cdkOverlayOrigin">
    <mat-icon>smart_toy</mat-icon>
  </button>

  <!-- Chat Panel Overlay -->
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="chatTrigger"
    [cdkConnectedOverlayOpen]="chatPanelOpen"
    [cdkConnectedOverlayPositions]="chatPanelPositions"
    (detach)="chatPanelOpen = false">
    <div class="chat-overlay-panel d-flex flex-column"
         cdkDrag cdkDragRootElement=".cdk-overlay-pane"
         libChatOverlayResize #chatResize="libChatOverlayResize">
      <div class="chat-resize-handle chat-resize-nw" (mousedown)="chatResize.onResizeStart($event, 'nw')" aria-label="Resize from top-left"></div>
      <div class="chat-resize-handle chat-resize-ne" (mousedown)="chatResize.onResizeStart($event, 'ne')" aria-label="Resize from top-right"></div>
      <div class="chat-resize-handle chat-resize-sw" (mousedown)="chatResize.onResizeStart($event, 'sw')" aria-label="Resize from bottom-left"></div>
      <div class="chat-resize-handle chat-resize-se" (mousedown)="chatResize.onResizeStart($event, 'se')" aria-label="Resize from bottom-right"></div>
      <lib-chat-panel-hdr
        cdkDragHandle
        [title]="activeAgent()?.label ?? 'AI Assistant'"
        [agents]="agents"
        [selectedAgentId]="selectedAgentId() ?? ''"
        [showMinimize]="true"
        [showReset]="chatResize.isDirty()"
        (agentChange)="onAgentChange($event)"
        (newChatRequested)="onChatNewChat()"
        (minimizeClicked)="chatPanelOpen = false"
        (resetClicked)="chatResize.reset()" />
      @if (activeAgent()) {
        <lib-chat-container class="flex-fill" [agentId]="activeAgent()!.id" [threadId]="currentThreadId()" />
      }
    </div>
  </ng-template>

  <svg id="compass-controller" class="pointer" xmlns="http://www.w3.org/2000/svg" width="110" height="110" viewBox="0 0 152 152">
    <defs>
      <filter id="blur_2d">
        <feOffset dx="-3" dy="1" in="SourceAlpha" />
        <feGaussianBlur stdDeviation="2" result="blur" />
        <feFlood flood-opacity="0.35" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>

      <filter id="blur_3d">
        <feOffset dx="3" dy="1" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="2" result="blur2" />
        <feFlood flood-opacity="0.35" />
        <feComposite operator="in" in2="blur2" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g
      class="orientation-group"
      (transitionend)="transitionRotationEnd()"
      (transitionstart)="transitionRotationStart()"
      [ngClass]="orientation"
      style="transform: rotate(0deg) translate(76px, 76px)"
      [ngStyle]="{ transform: 'rotate(' + controllerRotation + 'deg) translate(76px,76px) ' }">
      <circle id="back" data-name="back" cx="0" cy="0" r="74" fill="#ffffff" />
      <path
        class="path-orientation"
        id="north-button"
        [class.disabled]="controllerBlocked"
        [class.selected]="orientation === 'N'"
        (click)="changeOrientation('N')"
        d="M0 0-53-53A75 75 0 0 1 53-53Z" />
      <path
        class="path-orientation"
        id="south-button"
        [class.disabled]="controllerBlocked"
        [class.selected]="orientation === 'S'"
        (click)="changeOrientation('S')"
        d="M0 0 53 53A75 75 0 0 1-53 53Z" />
      <path
        class="path-orientation"
        id="east-button"
        [class.disabled]="controllerBlocked"
        [class.selected]="orientation === 'E'"
        (click)="changeOrientation('E')"
        d="M0 0 53-53A75 75 0 0 1 53 53Z" />
      <path
        class="path-orientation"
        id="west-button"
        [class.disabled]="controllerBlocked"
        [class.selected]="orientation === 'W'"
        (click)="changeOrientation('W')"
        d="M0 0-53 53A75 75 0 0 1-53-53Z" />
      <text
        class="text-orientation north"
        [class.disabled]="!availableOrientation('N')"
        [ngStyle]="{ transform: 'rotate(' + textRotation + 'deg) ' }"
        [class.selected]="orientation === 'N'">
        <tspan x="0" y="-53">N</tspan>
      </text>
      <text
        class="text-orientation south"
        [class.disabled]="!availableOrientation('S')"
        [ngStyle]="{ transform: 'rotate(' + textRotation + 'deg)' }"
        [class.selected]="orientation === 'S'">
        <tspan x="0" y="67">S</tspan>
      </text>
      <text
        class="text-orientation east"
        [class.disabled]="!availableOrientation('E')"
        [ngStyle]="{ transform: 'rotate(' + textRotation + 'deg)  ' }"
        [class.selected]="orientation === 'E'">
        <tspan x="60" y="5">E</tspan>
      </text>
      <text
        class="text-orientation west"
        [class.disabled]="!availableOrientation('W')"
        [ngStyle]="{ transform: 'rotate(' + textRotation + 'deg)  ' }"
        [class.selected]="orientation === 'W'">
        <tspan x="-60" y="5">W</tspan>
      </text>
    </g>

    <g id="mode-controller" transform="translate(76,76)">
      <circle id="back" data-name="back" cx="0" cy="0" r="45" fill="#4d5154" />
      <g>
        <path
          id="2d-button"
          filter="url(#blur_2d)"
          class="path-mode"
          [class.selected]="mode.value === 'VERTICAL'"
          (click)="viewerService.is3DMode() && changeMode()"
          d="M0 -45-0 45A45 45 0 0 1 -0-45Z"
          fill="#454545"
          stroke="white"
          stroke-width="1"></path>
        <path
          id="3d-button"
          filter="url(#blur_3d)"
          class="path-mode"
          [class.selected]="mode.value === 'OBLIQUE'"
          matTooltip="{{ get3DModeMessage() }}"
          (click)="!viewerService.is3DMode() && enable3DButton() && changeMode()"
          d="M0 -45-0 45A45 45 0 0 0 -0-45Z"
          stroke="white"
          fill="#4d5154"
          stroke-width="1"></path>
        <text class="text-mode">
          <tspan x="-22" y="5">2D</tspan>
        </text>
        <text class="text-mode" [class.disabled]="!viewerService.is3DMode() && !enable3DButton()">
          <tspan x="22" y="5">3D</tspan>
        </text>
      </g>
    </g>
  </svg>
</div>
